import { IconPhoto } from '@tabler/icons-react'
import { ReactNode } from 'react'
import InlineEditInput from '@/components/portal/InlineEditInput.tsx'
import { ProfTag } from '@/models/profTag.ts'
import TagBadge from '@/components/portal/TagBadge.tsx'

interface ProjectHeaderProps {
  title: string
  albumCount: number
  thumbnail?: string | null
  onTitleChange?: (newTitle: string) => Promise<void>
  tags?: ProfTag[]
  actions?: ReactNode
}

export default function ProjectHeader({ title, albumCount, thumbnail, onTitleChange, tags, actions }: ProjectHeaderProps) {
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-3 mb-8">
      <div className="w-16 h-16 bg-secondary flex items-center justify-center overflow-hidden flex-shrink-0 rounded-xl">
        {thumbnail ? (
          <img src={thumbnail} alt={title} className="w-full h-full object-cover" />
        ) : (
          <IconPhoto size={32} className="opacity-40" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        {onTitleChange ? (
          <InlineEditInput value={title} onSave={onTitleChange} className="min-w-[16rem]">
            <h1 className="text-3xl font-serif">{title}</h1>
          </InlineEditInput>
        ) : (
          <h1 className="text-2xl font-bold">{title}</h1>
        )}
        <div className="flex items-center gap-2 mt-1">
          <p className="text-sm opacity-60">
            {albumCount} {albumCount === 1 ? 'Album' : 'Alben'}
          </p>
          {tags && tags.length > 0 && (
            <div className="flex gap-1">
              {tags.map(t => <TagBadge key={t.id} tag={t} size="sm" />)}
            </div>
          )}
        </div>
      </div>
      {actions && (
        /* Mobile: wraps onto its own row below the title, buttons side by side.
           Desktop: right of the title. */
        <div className="flex items-center gap-2 w-full md:w-auto md:ml-auto md:flex-shrink-0">
          {actions}
        </div>
      )}
    </div>
  )
}
